import Vue from "vue";
import Vuetify, { colors } from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      dark: {
        accent: colors.blue.base,
      },
      light: {
        accent: colors.blue.darken2,
      }
    },
    dark: true
  }
});
